import type { ReactNode } from "react";

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  /** Breadcrumb or back link rendered above the title. */
  eyebrow?: ReactNode;
}

export function PageHeader({ title, description, actions, eyebrow }: PageHeaderProps) {
  return (
    <header className="mb-6 flex flex-wrap items-start justify-between gap-4">
      <div>
        {eyebrow && (
          <div className="mb-1 text-xs uppercase tracking-wide text-ink-500 dark:text-ink-400">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-2xl text-ink-900 dark:text-ink-50">{title}</h1>
        {description && (
          <p className="mt-1 max-w-prose text-sm text-ink-600 dark:text-ink-400">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 no-print">{actions}</div>}
    </header>
  );
}
